import React, { useLayoutEffect, useState } from 'react';
import {useSelector} from "react-redux";

export default function useMainCanvasSize() {
	const app = useSelector(state => state.app);
	const isClient = typeof window === 'object';
	const [windowSize, setWindowSize] = useState(getSize);

	function getSize() {
		const leftDrawerWidth = (app.leftDrawerOpen ? app.leftDrawerWidth : 0);
		const rightDrawerWidth = (app.rightDrawerOpen ? app.rightDrawerWidth : 0)

		return {
			width: isClient ? (window.innerWidth - leftDrawerWidth - rightDrawerWidth) : undefined,
			height: isClient ? window.innerHeight - app.toolbarHeight : undefined
		};
	}

	useLayoutEffect(() => {
		if (!isClient) {
			return false;
		}

		setTimeout(function() {
			setWindowSize(getSize());
		}, 0)

	}, [app.leftDrawerOpen, app.rightDrawerOpen, app.toolbarHeight]); // Empty array ensures that effect is only run on mount and unmount

	return windowSize;
}